import { Card, CardHeader, CardTitle, CardContent } from '@lean-agility/design-system/react';
import { LicenseStatusCard } from '../molecules/LicenseStatusCard';
import { LicenseUploadForm } from '../molecules/LicenseUploadForm';

export function LicenseAdminPanel() {
  return (
    <div
      className="
        grid grid-cols-1 gap-6
        lg:grid-cols-2
      "
    >
      <LicenseStatusCard />
      <Card>
        <CardHeader>
          <CardTitle>Upload License</CardTitle>
        </CardHeader>
        <CardContent>
          <LicenseUploadForm />
        </CardContent>
      </Card>
    </div>
  );
}
